import dayjs from "dayjs";
import { defineComponent, reactive, toRefs } from "vue";
import { Log } from "~/extensions/utils";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { myPageStore } from "~/store/MyPageStore";
import { store } from "../../store/TaikyoStore";
const log = Log.create("KaiyakuTable");
export default defineComponent({
    name: "KaiyakuTable",
    props: {
        kouzaForInput: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const personal = reactive(myPageStore.personal);
        const taikyo = reactive(store.taikyoEntity);
        const nyukyokeiyaku = myPageStore.personal.nyukyokeiyakuList.find(item => {
            return item.orgNyukyokeiyakuNo === myPageStore.selectedNyukyokeiyakuNo;
        });
        const addressAll = myPageStore.selectedNyukyokeiyaku?.addressAll;
        const kouzaForInput = props.kouzaForInput;
        const getAddressRenraku = () => {
            let address = "";
            if (!isNullOrUndefined(taikyo.postCode)) {
                address += "〒" + taikyo.postCode + "\r\n";
            }
            if (!isNullOrUndefined(taikyo.adr1)) {
                address += taikyo.adr1;
            }
            if (!isNullOrUndefined(taikyo.adr2)) {
                address += "\r\n" + taikyo.adr2;
            }
            if (!isNullOrUndefined(taikyo.adr3)) {
                address += "\r\n" + taikyo.adr3;
            }
            return address;
        };
        // 口座番号に0埋める
        const getKouzaNo = () => {
            let kouzaNo = taikyo.henkinKouzaNo;
            if (kouzaNo !== "" && kouzaNo.length < 7) {
                kouzaNo = kouzaNo.padStart(7, "0");
            }
            return kouzaNo;
        };
        const getShopAdr = () => {
            if (!nyukyokeiyaku) {
                return "";
            }
            return "〒" + nyukyokeiyaku.shopPostcode + "  " + nyukyokeiyaku.shopAdr1 + nyukyokeiyaku.shopAdr2;
        };
        return {
            ...toRefs(store),
            personal,
            nyukyokeiyaku,
            dayjs,
            getKouzaNo,
            taikyo,
            kouzaForInput,
            getAddressRenraku,
            getShopAdr,
            addressAll
        };
    }
});
